<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4 text-truncate">Add GC Code
            {{ (inputCode) ? (" - " + this.inputCode) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate"> View GC Code - {{ this.inputCode }}</h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">Edit GC Code - {{ this.inputCode }}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory">
                <b><label>Created By: </label></b>
                {{ inputCreatedBy || "System" }} | {{ inputCreatedAt | dateFilter }}
                <br>
                <b><label>Updated By:</label></b>
                {{ inputUpdatedBy || "System" }} | {{ inputUpdatedAt | dateFilter }}
                <hr/>
                <a-steps :current="history_data.length" style='border-bottom: 1px solid #e0e0e0; width: auto;' class="py-2" size="small" direction="vertical" progress-dot>
                    <a-step v-for="history_data in history_data" :key="history_data.id" :title="formatStatus(history_data.action)" :subTitle="history_data.refcode" :description="formatDescription(history_data)" />
                    </a-steps>
            </b-tab>
        </b-tabs>
        <form id="form-proper">
            <fieldset v-if="customFormMode == 1" v-show="showDetails">
                <base-input alternative="" label="Code" placeholder="" v-model="inputCode"
                    input-classes="form-control" :disabled="disableCodeInput" />
                <base-input alternative="" label="GC Value" placeholder="" v-model="inputGCValue" input-classes="form-control"
                    required disabled/>
                <base-input alternative="" label="Status"><br>
                  <a-select showSearch v-if="!disableCodeInput"
                            v-model="selectedStatus"
                            placeholder="Select Status"
                            optionFilterProp="children"
                            style="width: 100%">
                    <a-select-option v-for="option in statusOptions"
                                    :key="option.key"
                                    :value="option.key">
                      {{option.value}}
                    </a-select-option>
                  </a-select>

                  <a-select showSearch v-else
                            v-model="selectedStatus"
                            placeholder="Select Status"
                            optionFilterProp="children"
                            disabled
                            style="width: 100%">
                    <a-select-option v-for="option in statusOptions2"
                                    :key="option.key"
                                    :value="option.key">
                      {{option.value}}
                    </a-select-option>
                  </a-select>
                  </base-input>
                <base-input alternative="" label="Remark"  >
                    <textarea rows="4" class="form-control" v-model="inputRemark" :disabled="disableInput" />
                </base-input>
            </fieldset>
            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'"
                    style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <a-spin :spinning="loading">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right"
                        @click.prevent="create">Add</button>
                    <button v-else type="button" class="btn btn-primary float-right"
                        @click.prevent="update">Update</button>
                    </a-spin>
                </div>
                <div v-else
                    style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right"
                        @click.prevent="$emit('closeDrawer', null)">Close</button>
                </div>
            </div>
        </form>
    </div>
</template>


<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import ValidateField from '../../components/validateFormUtils.js'
import { mapState } from 'vuex'
import moment from 'moment'


var component_x;
export default {
    components: {
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType']),
    },
    mounted: async function () {
    
        if (this.serverType == 'branch') {
            this.disableInput = true;
            this.disableCodeInput = true;
        } else {
            if (this.$attrs.viewMode == true) {
                this.disableInput = true;
                this.disableCodeInput = true;
            }
        }
        component_x = this
        if (component_x.profileId > 0) {
            var data = await HTTPRequest.getRequest(component_x.endPoint + 'gift_certificates/' + component_x.profileId, null)
            if (data == undefined) {
                component_x.$router.go()
            } else {
                if (data["error"] == undefined) {
                    component_x.history_data = data["gc_code_history"]
                    component_x.inputCode = data["code"]
                    component_x.inputGCValue = data["amount"]
                    component_x.selectedStatus = data["status"]
                    component_x.inputRemark = data["remark"]
                    component_x.inputCreatedBy = data["created_by"]
                    component_x.inputCreatedAt = data["created_at"]
                    component_x.inputUpdatedBy = data["updated_by"]
                    component_x.inputUpdatedAt = data["updated_at"]
                    if(['C', 'I', 'A'].includes(data["status"]))
                        this.disableCodeInput = false;
                    else
                        this.disableCodeInput = true;
                } else {
                    this.errors = data["error"].split(",") //format will change when error message has comma
                    //component_x.$router.push("/")
                }
            }
        }
    },
    data: function () {
        return {
            history_data: [],
            product_id: this.$attrs.product_id,
            inputCode: '',
            inputGCValue: this.$attrs.gc_value,
            selectedStatus: '',
            showDetails: true,
            inputRemark: '',
            inputCreatedBy: '',
            inputCreatedAt: '',
            inputUpdatedBy: '',
            inputUpdatedAt: '',
            errors: [],
            // FOR META-DATA
            customFormMode: 1,
            customForm: {},
            profileData: {},
            shipping_method: {},
            formErrors: [],
            disableInput: false,
            disableCodeInput: false,
            loading: false,
            statusOptions : [
                {key: 'C', value: 'Created'},
                {key: 'A', value: 'Activated'},
                {key: 'I', value: 'Inactive'}
            ],
            statusOptions2 : [
                {key: 'C', value: 'Created'},
                {key: 'A', value: 'Activated'},
                {key: 'I', value: 'Inactive'},
                {key: 'S', value: 'Sold'},
                {key: 'U', value: 'Used'},
                {key: 'V', value: 'Voided'}
            ],
        }
    },
    filters: {
        dateFilter: function (timestamp) {
            return moment(timestamp).format('lll')
        }
    },
    methods: {
        formatDescription(data){
            return data.action_by + " | " + moment(data.refdate).format('LL LTS');
        },
        formatStatus(status){
            switch (status) {
            case 'A':
                return 'Activated'
            case 'I':
                return 'Inactive'
            case 'D':
                return 'Disabled'
            case 'C':
                return 'Created'
            case 'S':
                return 'Sold'
            case 'U':
                return 'Used'
            case 'V':
                return 'Voided'
            default:
                return status
            }
        },
        updateSettings(newFormSettings, settingsGrouping, errors) {
            var formSettingsCopy = this.shipping_method
            var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
            this.formErrors = errors

            if (this.customFormMode == 3) {
                this.errors = errors
            }

            this.shipping_method = mergedHash
        },
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        openDetails() {
            this.showDetails = true
        },
        openHistory() {
            this.showDetails = false
        },
        validateForm() {
            this.errors = [];
            this.errors.push(ValidateField.required('Code', this.inputCode));
            this.errors.push(ValidateField.required('GC Value', this.inputGCValue));
            this.errors.push(ValidateField.required('Status', this.selectedStatus));
            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        create: async function () {
            this.loading = true;
            if (!this.validateForm()) {
                var gcCodesPayload = {
                    gift_certificate: {
                        code: this.inputCode.trim(),
                        amount: this.inputGCValue,
                        status: this.selectedStatus,
                        remark: this.inputRemark,
                        product_id: this.product_id
                    }
                }
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'gift_certificates', null, gcCodesPayload)
                if (post_request == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    if (post_request["error"] == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = post_request["error"].split(",") //format will change when error message has comma
                        document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                    }
                }
            }
            this.loading = false;
        },
        update: async function () {
            this.loading = true;
            if (!this.validateForm()) {
                var gcCodesPayload = {
                    gift_certificate: {
                        code: this.inputCode.trim(),
                        amount: this.inputGCValue,
                        status: this.selectedStatus,
                        remark: this.inputRemark,
                        product_id: this.product_id
                    }
                }
                var put_request = await HTTPRequest.putRequest(this.endPoint + 'gift_certificates/' + this.profileId, null, gcCodesPayload)
                if (put_request == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    if (put_request["error"] == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = put_request["error"].split(",") //format will change when error message has comma
                        document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                    }
                }
            }
            this.loading = false;
        }
    }
}
</script>

<style>
</style>
